import React, { useEffect } from 'react';
import PolicyHolderClaimReviewAcceptedRejectedWordings from '../policyHolderClaimReviewAcceptedRejectedWordings/policyHolderClaimReviewAcceptedRejectedWordings';
import PolicyHolderLoginModal from '../policyHolderLoginModal/policyHolderLoginModal';
import PolicyHolderClaimDetails from '../policyHolderClaimDetails/policyHolderClaimDetails';
import PolicyHolderClaimRejectedModal from '../policyHolderClaimRejectedModal/policyHolderClaimRejectedModal';
import moment from 'moment';
import { useAppSelector } from '../../hooks/hooks';

type AcceptedRejectedWording = {
    title: string;
    subtitle: string;
    contact: string;
    aragTelephoneNumber: string | number;
    languageId: string;
};

type ClaimReviewOverviewObject = {
    formattedType: string;
    claimReference: string;
    createdDate: moment.MomentInput;
};
type Props = {
    claimReviewAnswersGroupedByStep: Array<any> | null;
    claimReviewOverview: null | ClaimReviewOverviewObject;
    submitting: boolean;
    handleUserInfoSubmit: (values: { email: string; passcode: string }) => void;
    acceptClaimReview: () => void;
    getRejectionFormClaimReview: () => void;
    rejectClaimReviewWithReason: (values: {
        acceptanceStatusReason: any;
    }) => void;
    acceptedRejectedWordings: AcceptedRejectedWording[];
    rejectedReasonClaimReviewWordings: any;
    changeClaimReviewStateAction: any;
    rejectFormLoading: boolean;
    claimReview: any;
};

const PolicyHolderReviewClaim = (props: Props): JSX.Element => {
    const {
        claimReviewAnswersGroupedByStep,
        claimReviewOverview,
        submitting,
        handleUserInfoSubmit,
        acceptClaimReview,
        getRejectionFormClaimReview,
        rejectClaimReviewWithReason,
        acceptedRejectedWordings,
        rejectedReasonClaimReviewWordings,
        changeClaimReviewStateAction,
        rejectFormLoading,
    } = props;

    return (
        <div>
            {acceptedRejectedWordings ? (
                <PolicyHolderClaimReviewAcceptedRejectedWordings
                    acceptedRejectedWordings={
                        Array.isArray(acceptedRejectedWordings)
                            ? acceptedRejectedWordings
                            : [acceptedRejectedWordings]
                    }
                />
            ) : claimReviewAnswersGroupedByStep &&
              claimReviewOverview &&
              !acceptedRejectedWordings ? (
                <PolicyHolderClaimDetails
                    acceptClaimReview={acceptClaimReview}
                    getRejectionFormClaimReview={getRejectionFormClaimReview}
                    submitting={submitting}
                    claimReviewOverview={claimReviewOverview}
                    claimReviewAnswersGroupedByStep={
                        claimReviewAnswersGroupedByStep
                    }
                    rejectFormLoading={rejectFormLoading}
                />
            ) : (
                <PolicyHolderLoginModal
                    submitting={submitting}
                    handleUserInfoSubmit={handleUserInfoSubmit}
                />
            )}

            {rejectedReasonClaimReviewWordings && (
                <PolicyHolderClaimRejectedModal
                    rejectClaimReviewWithReason={rejectClaimReviewWithReason}
                    rejectedReasonClaimReviewWordings={
                        rejectedReasonClaimReviewWordings
                    }
                    submitting={submitting}
                    changeClaimReviewStateAction={changeClaimReviewStateAction}
                />
            )}
        </div>
    );
};

export default PolicyHolderReviewClaim;
